import { render } from "./KlaipedaPort.vue?vue&type=template&id=2065dda0&scoped=true"
import script from "./KlaipedaPort.vue?vue&type=script&lang=js"
export * from "./KlaipedaPort.vue?vue&type=script&lang=js"

import "./KlaipedaPort.vue?vue&type=style&index=0&id=2065dda0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2065dda0"]])

export default __exports__